import {
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
} from "@mui/material";
import { useState } from "react";
import useQueryMutation from "hooks/useQueryMutation";
import { useQueryClient } from "@tanstack/react-query";

export default function NewGroupButton() {
  const queryClient = useQueryClient();
  const [isOpen, setIsOpen] = useState(false);
  const [name, setName] = useState("");
  const { mutate: createGroup, isPending } = useQueryMutation(
    "/customer",
    "POST",
    {
      onSuccess: () => {
        setIsOpen(false);
        setName("");
        queryClient.invalidateQueries({ queryKey: ["/customer"] });
      },
    }
  );

  const handleSave = () => {
    createGroup({ name });
  };

  const disabled = isPending || !name.trim();

  return (
    <>
      <Button
        variant="outlined"
        color="secondary"
        onClick={() => setIsOpen(true)}
      >
        NEW GROUP
      </Button>
      <Dialog
        open={isOpen}
        onClose={() => setIsOpen(false)}
        maxWidth="xs"
        fullWidth
      >
        <DialogTitle>New Group</DialogTitle>
        <DialogContent>
          <TextField
            autoFocus
            margin="dense"
            id="name"
            label="Group name"
            type="text"
            fullWidth
            variant="standard"
            value={name}
            required
            disabled={isPending}
            maxLength={32}
            onChange={(e) => setName(e.target.value)}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setIsOpen(false)}>CANCEL</Button>
          <Button onClick={handleSave} disabled={disabled}>
            {isPending ? "Saving..." : "SAVE"}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
